import { isUserAllowed } from '@lumapps/permissions';

import { METADATA_PERMISSIONS } from '../permissions';

export const isMetadataEditAllowed = isUserAllowed(METADATA_PERMISSIONS.METADATA_EDIT);
export const isMetadataDeleteAllowed = isUserAllowed(METADATA_PERMISSIONS.METADATA_DELETE);
